import {Menu, MenuType} from "./menu-item-shared";

const payments: Menu ={
  state: 'payments',
  name: 'menu.payments',
  type: MenuType.Static,
  icon: 'payment',
};

const history: Menu ={
  state: 'history',
  name: 'menu.history',
  type: MenuType.Static,
  icon: 'history'
};

const rfidCards: Menu ={
  state: 'rfidcards',
  name: 'menu.rfidcards',
  type: MenuType.Static,
  icon: 'nfc'
};

export const driverMenu: Menu = {
  state: 'driver',
  name: 'menu.driver',
  type: MenuType.Expandable,
  icon: 'directions_car',
  children: [ payments, history, rfidCards ],
};

